"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tr = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 8", ...props },
    react_1.default.createElement("path", { fill: "#E30A17", d: "M0 0h12v8H0z" }),
    react_1.default.createElement("circle", { cx: 4.25, cy: 4, r: 2, fill: "#fff" }),
    react_1.default.createElement("circle", { cx: 4.75, cy: 4, r: 1.6, fill: "#e30a17" }),
    react_1.default.createElement("path", { fill: "#fff", d: "m5.833 4 1.81.588-1.119-1.54v1.903l1.118-1.539z" })));
exports.default = Tr;
//# sourceMappingURL=Tr.js.map